import { Module } from "vuex";

interface NicknameState {
  checkHasNickname: boolean;
}

const nickname: Module<NicknameState, any> = {
  state: {
    checkHasNickname: JSON.parse(
      localStorage.getItem("checkHasNickname") || "false"
    ),
  },

  getters: {
    getCheckHasNickname(state: NicknameState): boolean {
      return state.checkHasNickname;
    },
  },
  mutations: {
    setCheckHasNickname(state: NicknameState, payload: boolean) {
      state.checkHasNickname = payload;
      localStorage.setItem("checkHasNickname", JSON.stringify(payload));
    },
    resetCheckNicknameStatus(state: NicknameState) {
      state.checkHasNickname = false;
    },
  },
};

export default nickname;
